var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"proyecto"},[_c('proyectos-planificar-form',{attrs:{"proyectoProp":_vm.proyecto,"idProp":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }